import { EMPTY, formatCoveragePct } from './utils';
import type { EvaluationCaseCoverage } from './types';

/** What a coverage tile's bar row shows (coverageReadout). */
export interface CoverageReadout {
  /** The bar's fill width, 0–100; null draws no fill. */
  fillPct: number | null;
  /** "62.5%", or "—" when there is nothing left to value. */
  pctText: string;
  label: string;
}

/**
 * The coverage tiles' bar row (case management and the picker), one answer for both: the percent
 * and "covers this package", or, when the TC team rejected every place, "—" and "nothing left to
 * value" with no fill.
 *
 * @param {EvaluationCaseCoverage} row - The case's coverage row.
 * @return {CoverageReadout} The row's text and fill.
 */
export function coverageReadout(row: EvaluationCaseCoverage): CoverageReadout {
  if (row.nothingToValue) {
    return { fillPct: null, pctText: EMPTY, label: 'nothing left to value' };
  }
  return {
    fillPct: row.coveragePct,
    pctText: `${formatCoveragePct(row.coveragePct)}%`,
    label: 'covers this package',
  };
}
